import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, OnInit, Signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AppService } from '@nk/access-block';
import { AppMembershipEntity, isScreeningActionEntity, ScreeningActionEntity, WithUuid } from '@nk/data-entities-lib';
import { EntityWithUuid, NkCardListItemAbstractComponent } from '@nk/ui-lib';
import { map, Observable, switchMap } from 'rxjs';

@Component({
  selector: 'nk-screening-action-latest-status-card-list-item',
  imports: [AsyncPipe, TranslateModule],
  templateUrl: './screening-action-latest-status-card-list-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScreeningActionLatestStatusCardListItemComponent<Entity extends EntityWithUuid>
  extends NkCardListItemAbstractComponent<Entity>
  implements OnInit
{
  public screeningAction: Signal<WithUuid<ScreeningActionEntity> | null> = computed(() => {
    const value = this.valueSignal();
    if (value && value.entity && value.prop) {
      const item = value.entity && value.entity[value.prop];
      if (isScreeningActionEntity(item)) {
        return item;
      }
    }
    return null;
  });
  public appMembershipEntityDict$!: Observable<{
    [uuid: string]: WithUuid<AppMembershipEntity>;
  }>;
  private _appService = inject(AppService);

  public ngOnInit(): void {
    const appUserUuid$ = this._appService.identityDataCache.get().pipe(map((identity) => identity.app_user.uuid));

    this.appMembershipEntityDict$ = appUserUuid$.pipe(
      switchMap((appUserUuid) => this._appService.appMembershipListByUserCache.get(appUserUuid)),
      map((data) => {
        return (
          data &&
          data.reduce((res: { [uuid: string]: WithUuid<AppMembershipEntity> }, i) => {
            res[i.uuid] = i;
            return res;
          }, {})
        );
      }),
    );
  }
}
